module.exports = __webpack_public_path__ + "static/media/medium.962306d7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/slides/FixedIcons/assets/medium.svg
// module id = 69
// module chunks = 0